import { render, staticRenderFns } from "./editAds.vue?vue&type=template&id=339df87d&lang=pug"
import script from "./editAds.vue?vue&type=script&lang=js"
export * from "./editAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports